module.exports = __webpack_public_path__ + "static/media/SS_LAH_80.488eb488.png";